import * as React from 'react';

const AccordionContext = React.createContext({
    scrollIntoView: true,
    padding: true,
});

export { AccordionContext as default };
//# sourceMappingURL=AccordionContext.js.map
